import { render, staticRenderFns } from "./SystemModalWindowView.vue?vue&type=template&id=d965a678&scoped=true&"
import script from "./SystemModalWindowView.vue?vue&type=script&lang=ts&"
export * from "./SystemModalWindowView.vue?vue&type=script&lang=ts&"
import style0 from "./SystemModalWindowView.vue?vue&type=style&index=0&id=d965a678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d965a678",
  null
  
)

export default component.exports